import React from "react";

interface ItemBarProps {
  lengthList: number;
  value: JSX.Element;
}

export default function ItemBar(props: ItemBarProps) {
  return (
    <div
      style={{
        width: `calc(100vw / (${props.lengthList} ))`,
        height: "100%"
      }}
    >
      {props.value}
    </div>
  );
}
